import React from "react";

// External Libraries
import classNames from "classnames";

// Stylesheets
import "./Tabs.scss";

// Constants
import { TAB_MAILING_LIST, TAB_TEMPLATES } from "../LeftSection";

function Tabs({ currentTab, onTabChange }) {
  return (
    <div className="tabs-main-container">
      <div className="px-8 py-8">
        <div
          className="d-flex flex-grow-1 align-items-center justify-content-start p-1 tab-btn-container"
          style={{
            borderRadius: "12px",
          }}
        >
          <div
            className={classNames(
              "d-flex justify-content-center align-items-center px-2 py-3 cursor-pointer request-tab",
              {
                "active-request-tab": currentTab === TAB_TEMPLATES,
                "inactive-request-tab": !(currentTab === TAB_TEMPLATES),
              }
            )}
            onClick={() => onTabChange(TAB_TEMPLATES)}
          >
            <div style={{ position: "relative", fontWeight: "500" }}>
              Templates
            </div>
          </div>
          <div
            className={classNames(
              "d-flex justify-content-center align-items-center px-2 py-3 cursor-pointer request-tab",
              {
                "active-request-tab": currentTab === TAB_MAILING_LIST,
                "inactive-request-tab": !(currentTab === TAB_MAILING_LIST),
              }
            )}
            onClick={() => onTabChange(TAB_MAILING_LIST)}
          >
            <div style={{ position: "relative", fontWeight: "500" }}>
              Mailing List
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tabs;
